import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify"; // Import Toastify
import "react-toastify/dist/ReactToastify.css"; // Import Toastify styles
import { useNavigate } from "react-router-dom"; // For navigation
import api from "../utils/api";
import heroImage from "../assets/Affiliate Sign up Graphic.png"; // Update the path if needed
import mobReg from "../assets/mobReg.png"; // Update the path if needed

import Logo from "../assets/layer1.png"; // Update the path if needed

const AffiliateRegister = ({ onClose, showLogin }) => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate(); // React Router navigation hook

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await api.post("/users/register", {
        fullName,
        email,
        password,
      });
      console.log("Registration successful:", response.data);

      // Show success toast
      toast.success("Registration Successful!", {
        position: "top-center",
        autoClose: 1000, // 1 second
      });

      // Close popup and redirect after a delay
      setTimeout(() => {
        onClose(); // Close the popup
        navigate("/"); // Redirect to the home page
      }, 1000);
    } catch (err) {
      console.error("Registration error:", err.response?.data || err.message);
      setError(err.response?.data?.message || "Registration failed");

      // Show error toast
      toast.error("Registration Failed. Please try again.", {
        position: "top-center",
        autoClose: 2000, // 2 seconds
      });
    }
  };

  return (

    <>
      <div className="hidden lg:flex fixed inset-0 items-center justify-center z-50 bg-gray-400 bg-opacity-30 backdrop-blur-md">
        {/* Toast Container */}
        <ToastContainer />

        <div className="relative bg-black bg-opacity-60 text-white rounded-lg shadow-lg p-8 max-w-4xl w-full flex flex-col md:flex-row md:items-stretch">
          {/* Left Section - Form */}
          <div className="w-full md:w-1/2 p-4 flex flex-col justify-center">
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-white rounded-full w-8 h-8 flex items-center justify-center transition hover:bg-gray-700"
            >
              ×
            </button>

            {/* Logo and Title */}
            <div className="text-center mb-6">
              <img src={Logo} alt="Logo" className="w-12 mx-auto md:w-16" />
              <h2 className="text-primary text-2xl font-bold mt-4 md:text-3xl">Create Account</h2>
            </div>

            {/* Error Message */}
            {error && <p className="text-red-500 text-center text-sm md:text-base">{error}</p>}

            {/* Registration Form */}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-primary mb-1">Name</label>
                <input
                  type="text"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                  className="w-full px-4 py-2 rounded-lg bg-white text-black focus:outline-none focus:ring focus:ring-yellow-400"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-primary mb-1">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full px-4 py-2 rounded-lg bg-white text-black focus:outline-none focus:ring focus:ring-yellow-400"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-primary mb-1">Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full px-4 py-2 rounded-lg bg-white text-black focus:outline-none focus:ring focus:ring-yellow-400"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-primary rounded-lg text-gray-800 font-bold py-2 hover:bg-yellow-500 transition duration-200"
              >
                Sign Up
              </button>
            </form>

            {/* Login Link */}
            <p className="text-sm mt-4 text-center text-primary">
              Already have an account?{" "}
              <button
                className="hover:underline"
                onClick={() => {
                  onClose(); // Close the register popup
                  showLogin(); // Show the login popup
                }}
              >
                Sign in now
              </button>
            </p>
          </div>

          {/* Right Section - Hero Image */}
          <div className="w-full  md:w-1/2 p-4 lg:flex md:flex hidden items-center">
            <img
              src={heroImage}
              alt="Promo"
              className="rounded-md object-cover w-full h-40 md:h-full "
            />
          </div>
          <div className="w-full  p-4   items-center lg:hidden">
            <img
              src={mobReg}
              alt="Promo"
              className="rounded-md object-cover w-full h-40 md:h-full "
            />
          </div>
        </div>
      </div>

      <div className="fixed inset-0 flex  items-center justify-center z-50 bg-gray-400 bg-opacity-30 backdrop-blur-md lg:hidden">
        {/* Toast Container */}
        <ToastContainer />

        <div className="relative bg-black mt-14 mb-14 mr-12 ml-12 bg-opacity-60 text-white rounded-lg shadow-lg p-8 max-w-4xl w-full lg:w-full md:flex-row md:items-stretch">
          {/* Left Section - Form */}
          <div className="w-full md:w-1/2 p-4 flex flex-col justify-center">
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-4 mt-20 right-4 text-white rounded-full w-8 h-8 flex items-center justify-center transition hover:bg-gray-700"
            >
              ×
            </button>

            {/* Logo and Title */}
            <div className="text-center mb-6">
              <img src={Logo} alt="Logo" className="w-12 mx-auto md:w-16" />
              <h2 className="text-primary text-2xl font-bold mt-4 md:text-3xl">Create Account</h2>
            </div>

            {/* Error Message */}
            {error && <p className="text-red-500 text-center text-sm md:text-base">{error}</p>}

            {/* Registration Form */}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-primary mb-1">Name</label>
                <input
                  type="text"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                  className="w-full px-4 py-2 rounded-lg bg-white text-black focus:outline-none focus:ring focus:ring-yellow-400"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-primary mb-1">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full px-4 py-2 rounded-lg bg-white text-black focus:outline-none focus:ring focus:ring-yellow-400"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-primary mb-1">Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full px-4 py-2 rounded-lg bg-white text-black focus:outline-none focus:ring focus:ring-yellow-400"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-primary rounded-lg text-gray-800 font-bold py-2 hover:bg-yellow-500 transition duration-200"
              >
                Sign Up
              </button>
            </form>

            {/* Login Link */}
            <p className="text-sm mt-4 text-center text-primary">
              Already have an account?{" "}
              <button
                className="hover:underline"
                onClick={() => {
                  onClose(); // Close the register popup
                  showLogin(); // Show the login popup
                }}
              >
                Sign in now
              </button>
            </p>
          </div>

          {/* Right Section - Hero Image */}
          <div className="w-full md:w-1/2 p-4 hidden lg:flex md:flex items-center">
            <img
              src={heroImage}
              alt="Promo"
              className="rounded-md object-cover w-full h-40 md:h-full"
            />
          </div>
          <div className="w-full md:hidden p-4 items-center">
            <img
              src={mobReg}
              alt="Promo"
              className="rounded-md object-cover w-full h-full"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AffiliateRegister;
